import { emptyViewProvider } from '@/components/ui/widget/views/empty/empty.view';
import { idViewProvider } from '@/components/ui/widget/views/id/id.view';
import { activityViewProvider } from './activity/activity.view';
import { arrayViewProvider } from './array/array.view';
import { avatarViewProvider } from './avatar/avatar.view';
import { booleanViewProvider } from './boolean/boolean.view';
import { boxViewProvider } from './box/box.view';
import { codeViewProvider } from './code/code.view';
import { commentViewProvider } from './comment/comment.view';
import { commentFeedViewProvider } from './commentFeed/commentFeed.view';
import { dataTabViewProvider } from './dataTab/dataTab.view';
import { dateViewProvider } from './date/date.view';
import { fileViewProvider } from './file/file.view';
import { fileCompactViewProvider } from './fileCompact/fileCompact.view';
import { htmlViewProvider } from './html/html.view.tsx';
import { iconViewProvider } from './icon/icon.view';
import { keyValueViewProvider } from './keyValue/keyValue.view';
import { labelsViewProvider } from './labels/labels.view';
import { linkViewProvider } from './link/link.view';
import { listViewProvider } from './list/list.view';
import { listCompactViewProvider } from './listCompact/listCompact.view';
import { numberViewProvider } from './number/number.view';
import { progressViewProvider } from './progress/progress.view';
import { proseViewProvider } from './prose/prose.view';
// import AnswerView from './answer';
import { statusViewProvider } from './status/status.view';
import { tableViewProvider } from './table/table.view';
import { textViewProvider } from './text/text.view';
import { windowViewProvider } from './window/window.view';

/* views map */
// views are plain object literals that can provide access to
// 1 - component: the component to display
// 2 - getSortConfig: a default sorting configuration
// 3 - getFilterConfig: a default filtering configuration
// 4 - getDefaultWidth: a default width, for example for table columns sizing
// 5 - getStringifyFunction: a function to report how the view exports itself to string
// 6 - getEditedPath: a function to report if and which path can be edited in this view
const viewsMap = {
  number: numberViewProvider,
  progress: progressViewProvider,
  text: textViewProvider,
  status: statusViewProvider,
  link: linkViewProvider,
  labels: labelsViewProvider,
  date: dateViewProvider,
  activity: activityViewProvider,
  icon: iconViewProvider,
  prose: proseViewProvider,
  list: listViewProvider,
  html: htmlViewProvider,
  code: codeViewProvider,
  window: windowViewProvider,
  keyValue: keyValueViewProvider,
  box: boxViewProvider,
  array: arrayViewProvider,
  file: fileViewProvider,
  comment: commentViewProvider,
  table: tableViewProvider,
  dataTab: dataTabViewProvider,
  fileCompact: fileCompactViewProvider,
  avatar: avatarViewProvider,
  listCompact: listCompactViewProvider,
  boolean: booleanViewProvider,
  id: idViewProvider,
  empty: emptyViewProvider,
  // answer: AnswerView,
  commentFeed: commentFeedViewProvider
};

export type ViewType = keyof typeof viewsMap;
type SimpleView = { type: ViewType };
// get the relevant view
export const getView = <V extends SimpleView>(view?: V) => {
  if (!view) return textViewProvider;
  return viewsMap[view.type] || textViewProvider;
};
